import apk from "./contrall-2.29(111)-release.apk";

export default apk;
